import {AppUrls} from 'shared/config/model/urls';

import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {userSelector} from './authSlice';

import {
    EMAIL_DELETE_REDIRECT_KEY,
    EMAIL_PROBLEM_REDIRECT_KEY,
    EMAIL_WARNING_REDIRECT_KEY,
    shouldRedirectEmailDelete,
    shouldRedirectEmailProblem,
    shouldRedirectEmailWarning,
} from '../lib/emailRedirect';

const redirectOnce = (storageKey: string, url: string, now: number) => {
    localStorage.setItem(storageKey, now.toString());
    window.location.href = url;
};

export const useEmailStatusRedirects = () => {
    const user = useSelector(userSelector);
    const error = user?.last_email_error;
    const createdAt = user?.created_at;
    const deleteEmail = user?.confirm_email_deadline;
    const emailConfirmed = user?.email_confirmed;

    useEffect(() => {
        const now = Date.now();
        const last = localStorage.getItem(EMAIL_WARNING_REDIRECT_KEY);
        if (shouldRedirectEmailWarning(createdAt, emailConfirmed, last, now)) {
            redirectOnce(EMAIL_WARNING_REDIRECT_KEY, AppUrls.EMAIL_WARNING, now);
        }
    }, [createdAt, emailConfirmed]);

    useEffect(() => {
        const now = Date.now();
        const last = localStorage.getItem(EMAIL_DELETE_REDIRECT_KEY);
        if (shouldRedirectEmailDelete(deleteEmail, last, now)) {
            redirectOnce(EMAIL_DELETE_REDIRECT_KEY, AppUrls.EMAIL_DELETE, now);
        }
    }, [deleteEmail]);

    useEffect(() => {
        const now = Date.now();
        const last = localStorage.getItem(EMAIL_PROBLEM_REDIRECT_KEY);
        if (shouldRedirectEmailProblem(error, last, now)) {
            redirectOnce(EMAIL_PROBLEM_REDIRECT_KEY, AppUrls.EMAIL_PROBLEM, now);
        }
    }, [error]);
};
